import { render, staticRenderFns } from "./RegionTeamForm.vue?vue&type=template&id=b36044f4&scoped=true"
import script from "./RegionTeamForm.vue?vue&type=script&lang=js"
export * from "./RegionTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36044f4",
  null
  
)

export default component.exports